export const environment = {
  production: false,
  staging: true,
  appstraxServicesUrl: 'https://appstrax-services-eluk.codecapsules.co.za/',
  appstraxServicesApiKey: '18oPKcu020MiMbbdn00CgCQFzGsjc2',
  apiUrl: 'https://time-tracker-api-nxms.codecapsules.co.za',
}; 